import { Card, CardContent, Typography, Grid } from '@mui/material'
import { labTestSampleGradeChoices } from '../../../utils/constants'
import { formatDisplayDate } from '../../../utils/helpers'

const Field = ({ label, value }) => (
  <Grid item xs={6} sm={3}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1">{value ?? '—'}</Typography>
  </Grid>
)

const ClinicalDetailCard = ({ record }) => {
  const gradeChoice = labTestSampleGradeChoices.find((g) => g.value === record?.labTestSampleGrade)
  const showGrade = record?.labTestResult === 'Positive'
  const isRestricted = ['pendingConfirmation', 'manualReview'].includes(record?.status)

  if (isRestricted) {
    return (
      <Card>
        <CardContent>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
            Clinical Detail
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {record?.status === 'manualReview'
              ? 'Detailed clinical information is temporarily unavailable while this kit is under manual review.'
              : 'Detailed clinical information is temporarily unavailable while this kit is pending confirmation.'}
          </Typography>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
          Clinical Detail
        </Typography>
        <Grid container spacing={2}>
          <Field label="Weeks Since Vasectomy" value={record?.weeksSinceVasectomy} />
          <Field label="Sample Collected" value={formatDisplayDate(record?.specimenCollectionDate)} />
          <Field label="Test Date" value={formatDisplayDate(record?.labTestedAt)} />
          {showGrade && <Field label="Result Grade" value={gradeChoice?.label} />}
        </Grid>
      </CardContent>
    </Card>
  )
}

export default ClinicalDetailCard
